module.exports = __webpack_public_path__ + "static/media/homepage_curriculum_scroll.0b90b959.png";